"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IllegalEntityError = void 0;
var tslib_1 = require("tslib");
var PersistentError_1 = require("./PersistentError");
var IllegalEntityError = /** @class */ (function (_super) {
    tslib_1.__extends(IllegalEntityError, _super);
    /**
     * @param entity - The entity which cause the error
     */
    function IllegalEntityError(entity) {
        var _this = _super.call(this, "Entity ".concat(entity, " is not a valid entity")) || this;
        _this.entity = entity;
        return _this;
    }
    return IllegalEntityError;
}(PersistentError_1.PersistentError));
exports.IllegalEntityError = IllegalEntityError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSWxsZWdhbEVudGl0eUVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiSWxsZWdhbEVudGl0eUVycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFBQSxxREFBb0Q7QUFHcEQ7SUFBd0MsOENBQWU7SUFNckQ7O09BRUc7SUFDSCw0QkFBWSxNQUFjO1FBQTFCLFlBQ0Usa0JBQU0saUJBQVUsTUFBTSwyQkFBd0IsQ0FBQyxTQUVoRDtRQURDLEtBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFDOztJQUN2QixDQUFDO0lBQ0gseUJBQUM7QUFBRCxDQUFDLEFBYkQsQ0FBd0MsaUNBQWUsR0FhdEQ7QUFiWSxnREFBa0IifQ==